import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {Side} from '../../../enums/side';
import {DexLpTradeWidgetSettings, DexLpTradeWidgetSettingsDef} from './dex-lp-trade-widget-settings';

@Injectable()
export class DexLpTradeWidgetSettingsService implements WidgetSettingsService {

    private defaultSettingsDef: DexLpTradeWidgetSettingsDef = {
        title:  null,
        side:   Side.BUY,
        symbol: undefined,
        qty:    '0'
    };

    public getDefaultSettings(): Observable<DexLpTradeWidgetSettings> {
        return this.fromDefinition(this.defaultSettingsDef);
    }

    public fromDefinition(settingsDef: DexLpTradeWidgetSettingsDef): Observable<DexLpTradeWidgetSettings> {
        return of<DexLpTradeWidgetSettings>({
            title:        null,
            side:         settingsDef.side,
            symbol:       settingsDef.symbol,
            assetSymbol:  settingsDef.assetSymbol,
            qty:          settingsDef.qty,
            initialError: settingsDef.initialError
        } satisfies DexLpTradeWidgetSettings);
    }

    public toDefinition(settings: DexLpTradeWidgetSettings): DexLpTradeWidgetSettingsDef {
        return settings && {
            title:       null,
            side:        settings.side,
            symbol:      settings.symbol,
            assetSymbol: settings.assetSymbol,
            qty:         settings.qty
        } satisfies DexLpTradeWidgetSettingsDef;
    }

}
